import React from "react";
import PropTypes from "prop-types";
import Page from "../../components/Page";

import ShiftForm from "../../components/forms/ShiftForm";
import CenteredPageContentContainer from "../../components/CenteredPageContentContainer";
import PaperContainer from "../../components/PaperContainer";
import { FormMode } from "../../types/enums";

const CreateShiftPage = (props) => (
  <Page enableGoBack title="Dienst aanvragen">
    <CenteredPageContentContainer>
      <PaperContainer title="Dienst aanvragen">
        <ShiftForm
          mode={FormMode.CREATE}
          companyEmail={props.match.params.company_email}
          projectId={props.match.params.project_id}
        />
      </PaperContainer>
    </CenteredPageContentContainer>
  </Page>
);

CreateShiftPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      company_email: PropTypes.string.isRequired,
      project_id: PropTypes.string.isRequired,
    }),
  }),
};

export default CreateShiftPage;



// WEBPACK FOOTER //
// ./src/pages/Shift/CreateShiftPage.js